import React from 'react';
import { tipsConfig } from 'app/tipsConfig';
// MUI
import { Drawer, Typography, IconButton, Box, Divider } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

interface TipsDrawerProps {
  tipKey: keyof typeof tipsConfig | null;
  open: boolean;
  onClose: () => void;
}

export const TipsDrawer: React.FC<TipsDrawerProps> = ({ tipKey, open, onClose }) => {
  const tip = tipKey ? tipsConfig[tipKey] : null;

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      sx={{ zIndex: 1400 }}
      slotProps={{
        paper: { sx: { width: 420, p: 4 } }
      }}
    >
      <Box sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        mb: 2,
        gap: 2
      }}>
        <Typography variant="h6">{tip?.title}</Typography>
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </Box>
      <Divider sx={{ mx: -4 }} />
      <Box
        sx={{ overflowY: 'auto' }}
        dangerouslySetInnerHTML={{ __html: tip?.content || '' }}
      />
    </Drawer>
  );
};
